// App.js
import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AcceptPage from "./diy/AcceptPage";
import RejectPage from "./diy/RejectPage";
import AcceptRedymadePage from "./redymade/AcceptRedymadePage";
import RejectRedymadePage from "./redymade/RejectRedymadePage";
import AcceptModularPage from "./modular/AcceptModularPage";
import RejectModularPage from "./modular/RejectModularPage";
import AcceptDncPage from "./dnc/AcceptDncPage";
import RejectDncPage from "./dnc/RejectDncPage";
import AcceptRedymadeStagePage from "./project/readymade-stage/AcceptRedymadeStagePage";
import RejectRedymadeStagePage from "./project/readymade-stage/RejectRedymadeStagePage";
import AcceptDiyStagePage from "./project/diy-stage/AcceptDiyStagePage";
import RejectDiyStagePage from "./project/diy-stage/RejectDiyStagePage";
import AcceptModularStagePage from "./project/modular-stage/AcceptModularStagePage";
import RejectModularStagePage from "./project/modular-stage/RejectModularStagePage";
import AcceptDncStagePage from "./project/dnc-stage/AcceptDncStagePage";
import RejectDncStagePage from "./project/dnc-stage/RejectDncStagePage";
import Error from "./Error";
import AddonWork_Acc_Rej_Page from "./AdditionalWorkAccRej.jsx/AddonWork_Acc_Rej_Page";
import AcceptAdditionalPage from "./AdditionalWorkAccRej.jsx/AcceptAdditionalPage";
import RejectAdditionalPage from "./AdditionalWorkAccRej.jsx/RejectAdditionalPage";
import AcceptServiceOrderReqPage from "./service-order-reqAccRej.jsx/biil-to-company/AcceptServiceOrderReqPage";
import RejectServiceOrderReqPage from "./service-order-reqAccRej.jsx/biil-to-company/RejectServiceOrderReqPage";
import AcceptServiceOrderReqWithDiscPage from "./service-order-reqAccRej.jsx/bill-to-customer/with-req-to-admin/AcceptServiceOrderReqWithDiscAdmPage";
import RejectServiceOrderReqWithDiscPage from "./service-order-reqAccRej.jsx/bill-to-customer/with-req-to-admin/RejectServiceOrderReqWithDiscAdmPage";
import RejectServiceOrderReqWithoutCustPage from "./service-order-reqAccRej.jsx/bill-to-customer/without-req-to-customer/RejectServiceOrderReqWithoutCustPage";
import AcceptServiceOrderReqWithoutCustPage from "./service-order-reqAccRej.jsx/bill-to-customer/without-req-to-customer/AcceptServiceOrderReqWithoutCustPage";
import RejectServiceOrderReqWithDiscCustPage from "./service-order-reqAccRej.jsx/bill-to-customer/with-req-to-customer/RejectServiceOrderReqWithDiscCustPage";
import AcceptServiceOrderReqWithDiscCustPage from "./service-order-reqAccRej.jsx/bill-to-customer/with-req-to-customer/AcceptServiceOrderReqWithDiscCustPage";
import AcceptVelocraftPage from "./velocraft/AcceptVelocraftPage";
import RejectVelocraftPage from "./velocraft/RejectVelocraftPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/diyaccept" element={<AcceptPage />} />
        <Route path="/diyreject" element={<RejectPage />} />
        <Route path="/readymdaccept" element={<AcceptRedymadePage />} />
        <Route path="/readymdreject" element={<RejectRedymadePage />} />
        <Route path="/mdlaccept" element={<AcceptModularPage />} />
        <Route path="/mdlreject" element={<RejectModularPage />} />
        <Route path="/dncaccept" element={<AcceptDncPage />} />
        <Route path="/dncreject" element={<RejectDncPage />} />
        <Route path="/diyreject" element={<RejectPage />} />
        <Route path="/vlcrfaccept" element={<AcceptVelocraftPage />} />
        <Route path="/vlcrftreject" element={<RejectVelocraftPage />} />
        {/* --------project-------- */}

        <Route path="/stgrdmaccept" element={<AcceptRedymadeStagePage />} />
        <Route path="/stgdiyaccept" element={<AcceptDiyStagePage />} />
        <Route path="/mdlstageaccept" element={<AcceptModularStagePage />} />

        <Route path="/stgrdmreject" element={<RejectRedymadeStagePage />} />

        {/* <Route path="/addonacceptreject" element={<AddonWork_Acc_Rej_Page />} /> */}
        <Route path="/prjadtacptcust" element={<AcceptAdditionalPage />} />
        <Route path="/prjadtrejtcust" element={<RejectAdditionalPage />} />

        {/* -------- Service Order Req bill to COMPANY admin -------- */}
        <Route
          path="/prjordsracptadm"
          element={<AcceptServiceOrderReqPage />}
        />
        <Route
          path="/prjordsrrejtadm"
          element={<RejectServiceOrderReqPage />}
        />

        {/* -------- Service Order Req bill to *** CUSTOMER WITHOUT DISC *** req CUSTOMER-------- */}
        <Route
          path="/prjosreqacptcust"
          element={<AcceptServiceOrderReqWithoutCustPage />}
        />
        <Route
          path="/prjosreqrejtcust"
          element={<RejectServiceOrderReqWithoutCustPage />}
        />

        {/* -------- Service Order Req bill to CUSTOMER With disc req Admin-------- */}
        <Route
          path="/prjordsreqacptadm"
          element={<AcceptServiceOrderReqWithDiscPage />}
        />
        <Route
          path="/prjordsreqrejtadm"
          element={<RejectServiceOrderReqWithDiscPage />}
        />

        {/* -------- Service Order Req bill to CUSTOMER With disc req accpt customer-------- */}
        <Route
          path="/prjworacpadm"
          element={<AcceptServiceOrderReqWithDiscCustPage />}
        />
        <Route
          path="/prjworrjcadm"
          element={<RejectServiceOrderReqWithDiscCustPage />}
        />

        {/* --------Left - Pending-------- */}
        <Route path="/diystagereject" element={<RejectDiyStagePage />} />
        <Route path="/mdlstagereject" element={<RejectModularStagePage />} />
        <Route path="/dncstageaccept" element={<AcceptDncStagePage />} />
        <Route path="/dncstagereject" element={<RejectDncStagePage />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
